import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import { Form } from 'antd';
import Button from 'components/Button/Button';
import breadcrumbs from 'images/breadcrumbs.svg';
import classNames from 'classnames';
import {
	CreateCustomerContext,
	ICreateCustomerContext,
} from '../../../../../createCustomerState/createCustomerContext';
import style from './BtnBlock.module.scss';

export const BtnBlock: React.FC = () => {
	const {
		changeTypeOfModalWindow,
		name,
		email,
		emailBodyTemplate,
		clientType,
		billTemplateFileData,
		billAdvertisingImageData,
		billAdvertisingLink,
		priceType,
		tips0,
		tips1,
		tips2,
		tips3,
		defaultTips,
		ads,
		IDSelectedCustomerDefaultLanguage,
		IDsSelectedCustomerLanguages,
	} = useContext<ICreateCustomerContext>(CreateCustomerContext);

	const containerClasses = classNames(style.container, {
		[style.visible]:
			name ||
			email ||
			emailBodyTemplate ||
			clientType ||
			billTemplateFileData.fileId ||
			billAdvertisingImageData.fileId ||
			billAdvertisingLink ||
			priceType ||
			tips0 ||
			tips1 ||
			tips2 ||
			tips3 ||
			defaultTips ||
			ads ||
			IDSelectedCustomerDefaultLanguage ||
			IDsSelectedCustomerLanguages.length,
	});

	const handleCancel = () => {
		changeTypeOfModalWindow('toConfirmFieldsClearing');
	};

	return (
		<Form.Item>
			<div className={containerClasses} data-test="BtnBlock">
				<Button
					className={style.cancelBtn}
					theme="outlined"
					onClick={handleCancel}
					icon={
						<svg className={style.icon}>
							<use xlinkHref={`${breadcrumbs}#resetIcon`} />
						</svg>
					}>
					<Text translationNameSpace="form" translationKey="cancelButton" asFragment={true} />
				</Button>
				<Button className={style.saveBtn} theme="primaryBlue" type="submit">
					<Text translationNameSpace="form" translationKey="saveButton" asFragment={true} />
				</Button>
			</div>
		</Form.Item>
	);
};
